export default [
  {
    path: '/admin/defines/product-groups',
    name: 'ProductGroups',
    component: () => import('@/views/Admin/Defines/Product_groups/Index.vue'),
    meta: {
      pageTitle: 'Ürün Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/product-groups/add',
    name: 'ProductGroupAdd',
    component: () => import('@/views/Admin/Defines/Product_groups/Add.vue'),
    meta: {
      pageTitle: 'Ürün Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/product-groups',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/product-groups/edit/:id',
    name: 'ProductGroupEdit',
    component: () => import('@/views/Admin/Defines/Product_groups/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/Product-groups',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
